import { makeStyles, Toolbar } from '@material-ui/core'
import { Route, Switch, useHistory } from 'react-router-dom'
import { UserMenu } from './UserMenu'
import { AdminMenu } from './AdminMenu'
import { MountpointMenu } from './MountpointMenu'
import RinexMenu from './RinexService/RinexMenu'
import { useEffect } from 'react'
import { useToken } from 'App'

export function Menu() {
  const classes = useStyles()
  const history = useHistory()
  const { userRole, userId } = useToken()

  useEffect(() => {
    if (userRole === 'regular') history.replace(`/user/${userId}`)
  }, [userRole, userId])

  return (
    <Toolbar variant="dense" className={classes.menu}>
      <Switch>
        <Route path="/user/:userId" component={UserMenu} />
        <Route path="/rinex" component={RinexMenu} />
        <Route path="/mountpoint/:mid" component={MountpointMenu} />
        <Route path="/" component={AdminMenu} />
      </Switch>
    </Toolbar>
  )
}

const useStyles = makeStyles((theme) => ({
  menu: {
    overflowY: 'hidden',
    overflowX: 'auto',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#111',
    width: '100%',
    display: 'flex',
    // gap: 1,
    justifyContent: 'space-around',
    flexFlow: 'row',
    padding: 0,
    // overflowY: '',
  },
}))
